import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { EventDetailsComponent } from './pages/event-details/event-details.component';
import { NewBookingComponent } from './pages/book/new-booking/new-booking.component';
import { ValidateComponent } from './pages/validate/validate/validate.component';
import { HtmlDesignComponent } from './pages/html-design/html-design.component';
import { VatComponent } from './shared-components/vat/vat.component';
import { ChangePasswordComponent } from './shared-components/change-password/change-password.component';
import { MyTicketsTabsPage } from './pages/tickets/pages/my-tickets-tabs/my-tickets-tabs.page';
import { VerifyEmailComponent } from './pages/verify-email/verify-email.component';
import { AuthGuard } from './services/auth.guard';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'event-details/:id',
    component: EventDetailsComponent,
  },
  {
    path: 'book',
    component: NewBookingComponent,
  },
  {
    path: 'validate/:id',
    component: ValidateComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'html-design/:id',
    component: HtmlDesignComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'vat',
    component: VatComponent,
  },
  {
    path: 'auth/change-password/:id',
    component: ChangePasswordComponent,
  },
  {
    path: 'tickets/my-tickets',
    component: MyTicketsTabsPage,
    canActivate: [AuthGuard],
  },
  {
    path: 'auth/verify-email/:id',
    component: VerifyEmailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
